export enum USER_ROLE {
    SUPER_ADMIN = 'SUPER_ADMIN',
    ADMIN = 'ADMIN',
    MEMBER = 'MEMBER'
}

export enum ADDITIONAL_ROLES {
    BILLING_ADMIN = 'BILLING_ADMIN'
}
export enum USER_TYPE {
    INTERNAL = 'INTERNAL',
    EXTERNAL = 'EXTERNAL'
}

export enum CONTRACT_CHECKLIST_STATUS {
    COMPLIANCE = "COMPLIANCE",
    NOT_IN_COMPLIANCE = "NOT_IN_COMPLICANCE",
    SAVE_FOR_LATER = "SAVE_FOR_LATER"
}

export enum TAG_DATA_TYPES {
    TEXT = 'Text',
    NUMBER = 'Number',
    DATE = 'Date',
    DROPDOWN = 'Single/Multi Select',
}

export enum TAG_FEATURE {
    PROJECT = 'Project',
    DOCUMENT = 'Document',
}

export enum EXTRACTION_STATUS {
    IN_PROGRESS = 'IN_PROGRESS',
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED'
}

export enum JOB_TYPE {
    REFRESH = "REFRESH",
    TAG_EXTRACTION = "TAG_EXTRACTION",
    SINGLE_TAG_EXTRACTION = "SINGLE_TAG_EXTRACTION",
    CHECKLIST = "CHECKLIST",
    SINGLE_CHECKLIST_ITEM = "SINGLE_CHECKLIST_ITEM",
    SUMMARY = "SUMMARY",
    REPO_TAG_EXTRACTION = "REPO_TAG_EXTRACTION",
    GENERATE_DOCUMENT = "GENERATE_DOCUMENT",
    GENERATE_TEMPLATE = "GENERATE_TEMPLATE",
    GENERATE_ANALYSIS_EXCEL = "GENERATE_ANALYSIS_EXCEL",
    GEOTECHNICAL_ANALYSIS = "GEOTECHNICAL_ANALYSIS",
    GEOTECHNICAL_FORMULA_DASHBOARD = "GEOTECHNICAL_FORMULA_DASHBOARD",
    GEOTECHNICAL_VALUE_ENGINEERING = "GEOTECHNICAL_VALUE_ENGINEERING",
    GEOTECHNICAL_SUMMARY = "GEOTECHNICAL_SUMMARY",
    GEOTECHNICAL_ANALYSIS_SUMMARY = "GEOTECHNICAL_ANALYSIS_SUMMARY",
    GEOTECHNICAL_VENDOR_ANALYSIS = "GEOTECHNICAL_VENDOR_ANALYSIS",
    GEOTECHNICAL_AI_DASHBOARD = "GEOTECHNICAL_AI_DASHBOARD",
    ATTACHMENT_EMBEDDINGS_GENERATION = "ATTACHMENT_EMBEDDINGS_GENERATION",
    CLAUSE_EXTRACTION_RETRY = "CLAUSE_EXTRACTION_RETRY"
}

export enum JOB_STATUS {
    STARTED = "STARTED",
    COMPLETED = "COMPLETED",
    FAILED = "FAILED",
    CANCELLED = "CANCELLED"
}

export enum FILE_TYPE {
    WORD = 'docx',
    DOC = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    PDF = 'pdf',
    EXCEL = 'xlsx',
    POWERPOINT = 'pptx',
    HTML = 'html',
    TEXT = 'txt',
    CSV = 'csv',
    MARKDOWN = 'md',
    PYTHON = 'python',
    JSON = 'json',
    JPG = 'jpg',
    PNG = 'png',
    JPEG = 'jpeg',
}

export enum ONLY_OFFICE_EDITOR_TYPE {
    WORD = 'word',
    PDF = 'pdf',
    EXCEL = 'spreadsheet',
    POWERPOINT = 'slide'
}

export enum SUBSCRIPTION_STATUS {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
    CANCELLED = "CANCELLED"
}

export enum STANDARD_DOCUMENT_TYPES {
    CONTRACT = 'CONTRACT',
    SPECIFICATION = 'SPECIFICATION',
    SAFETY_DOCUMENT = 'SAFETY DOCUMENT',
    AGREEMENT = 'AGREEMENT',
    RFQ_QUOTE = 'RFQ QUOTE',
    SCOPE_OF_WORK = 'SCOPE OF WORK',
    HR_POLICY = 'HR POLICY',
    NOTICE = 'NOTICE',
    QUESTIONNAIRE = 'QUESTIONNAIRE',
    CONTRACT_PLAYBOOK = 'CONTRACT PLAYBOOK',
    REQUEST_FOR_PROPOSAL = 'REQUEST FOR PROPOSAL',
    PROPOSAL = 'PROPOSAL',
    BILL_OF_MATERIALS = 'BILL OF MATERIALS',
    STANDARD_AND_CODES = 'STANDARD AND CODES',
}

export enum ANSWER_GENERATION_TYPE {
    USER = 'USER',
    AI = 'AI',
    DEFAULT = 'DEFAULT',
}

export enum COMMENTS_TYPE {
    CONTRACT = 'Contract',
    QUESTION = 'FormQuestion',
    COMPARISON = 'DocumentCompare',
    GEOTECHNICAL_ANALYSIS = 'GeoTechnicalAnalysis'
}

export enum COMPLIANCE_STATUS {
    MET = 'Met',
    PARTIAL = 'Partial',
    NOT_MET = 'Not Met',
}

export enum TRACEABILITY_LEVEL {
    FULLY_TRACEABLE = 'Fully Traceable',
    PARTIALLY_TRACEABLE = 'Partially Traceable',
    NOT_TRACEABLE = 'Not Traceable'
}

export enum LOGIN_WITH {
    'EMAIL' = 'EMAIL',
    'USERNAME' = 'USERNAME',
}

export enum PROJECT_KNOWLEDGE_BASE {
    SPECIFICATIONS = 'Specifications',
    ADDENDUMS = 'Addendums',
    CONTRACTS = 'Contracts',
    BILL_OF_MATERIALS = 'Bill of materials (BOM)',
    PROPOSALS = 'Proposals'
}

export enum TRIAL_LIFECYCLE_PHASE {
    ACTIVE_TRIAL = 'ACTIVE_TRIAL',
    EXPIRED_GRACE = 'EXPIRED_GRACE',
    INACTIVE_PENDING_DELETION = 'INACTIVE_PENDING_DELETION',
    DELETED = 'DELETED'
}
